// Token-based brand accents. Edit this list to change the custom colors used by
// avatars, tinted data-card rows, rails, and colored pills.
export const ACCENT_COLORS = [
  { token: "arawaks.campfireRed", cssVar: "var(--chakra-colors-arawaks-campfire-red)" },
  { token: "arawaks.skyBlue", cssVar: "var(--chakra-colors-arawaks-sky-blue)" },
  { token: "arawaks.jungleGreen", cssVar: "var(--chakra-colors-arawaks-jungle-green)" },
  { token: "arawaks.adventureOrange", cssVar: "var(--chakra-colors-arawaks-adventure-orange)" },
  { token: "arawaks.grapePurple", cssVar: "var(--chakra-colors-arawaks-grape-purple)" },
  { token: "arawaks.rose", cssVar: "var(--chakra-colors-arawaks-rose)" },
  { token: "arawaks.sunshineYellow", cssVar: "var(--chakra-colors-arawaks-sunshine-yellow)" },
  { token: "arawaks.tropicalTeal", cssVar: "var(--chakra-colors-arawaks-tropical-teal)" },
  { token: "arawaks.playfulIndigo", cssVar: "var(--chakra-colors-arawaks-playful-indigo)" },
  { token: "arawaks.clayOrange", cssVar: "var(--chakra-colors-arawaks-clay-orange)" },
  { token: "arawaks.forestGreen", cssVar: "var(--chakra-colors-arawaks-forest-green)" },
  { token: "arawaks.goldenYellow", cssVar: "var(--chakra-colors-arawaks-golden-yellow)" },
  { token: "arawaks.lagoonTeal", cssVar: "var(--chakra-colors-arawaks-lagoon-teal)" },
  { token: "arawaks.orchidPurple", cssVar: "var(--chakra-colors-arawaks-orchid-purple)" },
  { token: "arawaks.treeBarkBrown", cssVar: "var(--chakra-colors-arawaks-tree-bark-brown)" },
  { token: "arawaks.blueGray", cssVar: "var(--chakra-colors-arawaks-blue-gray)" },
];

export function stableHash(input) {
  const str = String(input ?? "").trim();
  if (!str) return 0;

  let hash = 0;
  for (let i = 0; i < str.length; i += 1) {
    hash = (hash * 31 + str.charCodeAt(i)) >>> 0;
  }
  return hash;
}

function accentForSeed(seed) {
  const normalizedSeed = String(seed ?? "").trim();
  if (!normalizedSeed) return ACCENT_COLORS[0];
  return ACCENT_COLORS[stableHash(normalizedSeed) % ACCENT_COLORS.length];
}

export function getAccentHexColor(seed, fallback = ACCENT_COLORS[0].token) {
  const normalizedSeed = String(seed ?? "").trim();
  if (!normalizedSeed) return fallback;
  return accentForSeed(normalizedSeed).token;
}

export function getAccentTint(seed, strength = 12) {
  const accent = accentForSeed(seed);
  const amount = typeof strength === "number" ? strength : Number.parseFloat(strength);
  const pct = Number.isFinite(amount) ? amount : 12;
  return `color-mix(in srgb, ${accent.cssVar} ${pct}%, transparent)`;
}
